module.exports = __webpack_public_path__ + "98f75029aba2149ee3513bfab201bdb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-768.jpg
// module id = 207
// module chunks = 0